import { useState } from 'react';
import InitiateTransferModal from '../../pages/Account/Transaction/InitiateTransferModal';
import TransferCompleteModal from '../../pages/Account/Transaction/TransferCompleteModal';

/**
 * @typedef {object} TransferMoreFundsProps
 * @property {boolean} open
 * @property {()=>void} onClose
 * @property {()=>void} onOpen
 *
 * @param {TransferMoreFundsProps} props
 */
function TransferMoreFunds(props) {
  const { onClose, open, onOpen } = props;
  const [transferCompleteModal, setTransferCompleteModal] = useState(false);
  const [initiateTransferredData, setInitiateTransferredData] = useState(false);

  return (
    <>
      {open && (
        <InitiateTransferModal
          isTransferModalOpen={open}
          closeTransferModal={() => onClose()}
          openTransferCompleteModal={(modalState) => setTransferCompleteModal(modalState)}
          initiateTransferedData={(initialData) => setInitiateTransferredData(initialData)}
          openTransection={null}
        />
      )}

      {transferCompleteModal && (
        <TransferCompleteModal
          transferCompleteModal={transferCompleteModal}
          setTransferCompleteModal={(modalState) => setTransferCompleteModal(modalState)}
          setTransactionDetailsOpen={() => {}}
          openInitiateTransfer={() => onOpen()}
          initiateTransferedData={initiateTransferredData}
        />
      )}
    </>
  );
}

export default TransferMoreFunds;
